// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axiosInstance from "../../API/axiosInstance";
// import { FaStar, FaEye, FaRupeeSign, FaMapMarkerAlt } from "react-icons/fa";
// import { getCurrentUser } from "../../Auth/UserServices";
// import useAuthCheck from "../../Auth/useAuthCheck";
// import ChatRoom from "../ChatRoom/ChatRoom";
// import ImageGallery from "./Image Gallery/ImageGallery";
// import "./vendorDetails.css";
// import "react-responsive-carousel/lib/styles/carousel.min.css";

// export default function VendorDetails() {
//   const [vendor, setVendor] = useState(null);
//   const [user, setUser] = useState(null);
//   const [vendorServices, setVendorServices] = useState([]);
//   const [token, setToken] = useState(null);
//   const [rating, setRating] = useState(0);
//   const [comment, setComment] = useState("");
//   const [hover, setHover] = useState(null);
//   // const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState({
//     title: "",
//     content: "",
//     rating: 0,
//     userId: "",
//     username: "",
//     vendorId: ""
//   });



//   const { vendor_id } = useParams();
//   const navigate = useNavigate();

//   useAuthCheck();

//   useEffect(() => {
//     const fetchToken = () => {
//       const storedToken = localStorage.getItem("token");
//       if (storedToken) setToken(storedToken);
//     };
//     fetchToken();
//   }, []);

//   useEffect(() => {
//     if (!token) return;

//     const fetchVendorDetails = async () => {
//       try {
//         const res = await axiosInstance.get(`/vendor/getVendorById/${vendor_id}`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         if (res.status === 200) setVendor(res.data);
//       } catch (err) {
//         console.error("Error fetching vendor:", err);
//       }
//     };

//     const fetchUser = async () => {
//       try {
//         const currUser = await getCurrentUser();
//         if (currUser) setUser(currUser);
//       } catch (err) {
//         console.error("User fetch failed:", err);
//       }
//     };

//     const fetchServices = async () => {
//       try {
//         const res = await axiosInstance.get(`/service/${vendor_id}/all`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         if (res.status === 200) setVendorServices(res.data);
//       } catch (err) {
//         console.error("Service fetch failed:", err);
//       }
//     };

//     fetchVendorDetails();
//     fetchUser();
//     fetchServices();
//   }, [vendor_id, token]);

//   const handleReviewSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       await axiosInstance.post(
//         `/vendor/review/${vendor_id}`,
//         { rating, comment },
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       setRating(0);
//       setComment("");
//       const res = await axiosInstance.get(`/vendor/getVendorById/${vendor_id}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (res.status === 200) setVendor(res.data);
//     } catch (err) {
//       console.error("Error submitting review:", err);
//     }
//   };

//   if (!vendor || !user) return <p className="text-center p-10">Loading...</p>;


//   //review functions
//   const createReview = async (e) => {
//     e.preventDefault();
//     formData.userId = user.id;
//     formData.vendorId = vendor.id;
//     formData.username = user.username;
//     console.log("Submitting review:", formData);


//     const response = await axiosInstance.post('/reviews', formData, {
//       headers: { "Content-Type": "application/json" }
//     });

//     if (response.data) {
//       console.log('Review added..!');
//     }
//     else {
//       console.log('Error adding review ..!');
//     }

//     // Reset form
//     setFormData({
//       title: "",
//       content: "",
//       rating: 0,
//     });
//     setHover(null);
//     setRating(0);
//   };


//   const handleReviewChange = (e) => {
//     const { id, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [id]: value,
//     }));
//   };

//   const handleRating = (value) => {
//     setRating(value);
//     onRatingChange(value);
//     setFormData((prev) => ({
//       ...prev,
//       rating: value,
//     }));
//   };


//   const onRatingChange = () => {
//   }


//   return (
//     <>
//       <div id="vendor-details-page">
//         <div className="container" id="vendor-details-container">
//           <section className="vendor-identity-section">
//             <h1>{vendor.business_name}</h1>
//             <h3>By <span>{vendor.vendor_name}</span></h3>
//           </section>
//         </div>
//       </div>

//       <div className="container" id="vendor-details-section">
//         <section className="vendor-details">
//           <h3 id="spotlight-title">Vendor Spotlight</h3>
//           <div className="row">
//             <div className="col-md-6 mb-4" id="carousel-col">
//               {vendor.business_photos?.length > 0 ? (
//                 <ImageGallery photos={vendor.business_photos} />
//               ) : (
//                 <img src="/fallback.jpg" alt="Fallback" className="img-fluid" />
//               )}
//             </div>
//             <div className="col-md-6 mb-4" id="vendor-info-col">
//               <div className="p-4 bg-light rounded shadow-sm">
//                 <h3 id="info-title">About vendor</h3>
//                 <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit...</p>
//                 <h4><strong>Location:</strong> {vendor.city}</h4>
//                 <h4><strong>Category:</strong> {vendor.business_category}</h4>
//                 <h4><strong>GST No:</strong> {vendor.gst_number}</h4>
//                 <h4><strong>Ratings:</strong>
//                   <span className="text-warning">★★★★☆</span> (4.2 ★)
//                 </h4>
//                 <h3 className="mt-4" id="info-title">Terms & Conditions</h3>
//                 <p>{vendor.terms_and_conditions}</p>
//               </div>
//             </div>
//           </div>

//           <section className="mb-5" id="vendor-services">
//             <h3 id="service-title">Services</h3>
//             <div className="row" id="card-deck">
//               {vendorServices.length > 0 ? (
//                 vendorServices.map((service, index) => (
//                   <div className="col-12 col-md-6 col-lg-4" key={index} id="service-col">
//                     <div className="card service-card">
//                       <span className="badge text-bg-warning m-2 px-3 py-2">{service.category}</span>
//                       <div className="service-image position-relative">
//                         <img
//                           src={service.images?.[0] || "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png"}
//                           alt={service.service_name}
//                           className="card-img-top rounded-top"
//                         />
//                       </div>
//                       <div className="card-body d-flex flex-column">
//                         <h5 className="card-title fw-bold">{service.service_name}</h5>
//                         <p className="card-text text-muted fs-6 vendor-service-description">
//                           {service.description}
//                         </p>

//                         <p className="price text-dark fw-semibold fs-5">
//                           <FaRupeeSign className="text-success" /> {service.min_price} - {service.max_price}
//                         </p>
//                         <div className="d-flex align-items-center text-muted fs-6">
//                           <FaStar className="text-warning" />
//                           <span className="ms-1">{service.ratings?.toFixed(1) || "N/A"}</span>
//                           <span className="ms-2">({service.reviews?.length || 0} reviews)</span>
//                         </div>
//                         <p className="location text-muted fs-6 d-flex align-items-center">
//                           <FaMapMarkerAlt className="me-1 text-danger" /> {service.location}
//                         </p>
//                         <p className="text-muted small">
//                           Created: {new Date(service.created_at).toLocaleDateString()}
//                         </p>
//                         <div className="mt-auto d-flex justify-content-between gap-2">
//                           <button className="btn btn-primary w-100" onClick={() => navigate(`/service-details/${service.id}`)}>
//                             <FaEye className="me-1" /> View
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="col-12">
//                   <p className="text-center text-muted">No services available.</p>
//                 </div>
//               )}
//             </div>
//           </section>

//           {/* Review Form */}
//           <h5 className="mb-3">Write a Review</h5>
//           <section className="review-form">
//             <form onSubmit={createReview}>
//               <div className="mb-3">
//                 <label htmlFor="title" className="form-label">Review title</label>
//                 <input
//                   className="form-control"
//                   id="title"
//                   name="title"
//                   placeholder="Review title..."
//                   value={formData.title}
//                   onChange={handleReviewChange}
//                 />
//               </div>

//               <div className="mb-3">
//                 <label htmlFor="content" className="form-label">Your Review</label>
//                 <textarea
//                   className="form-control"
//                   id="content"
//                   name="content"
//                   rows="3"
//                   placeholder="Share your thoughts..."
//                   value={formData.content}
//                   onChange={handleReviewChange}
//                 />
//               </div>

//               <div className="star-review mb-3">
//                 <h6>Rate your experience:</h6>
//                 <div className="stars d-flex gap-1">
//                   {[...Array(5)].map((_, index) => {
//                     const ratingValue = index + 1;
//                     return (
//                       <label key={ratingValue}>
//                         <input
//                           type="radio"
//                           name="rating"
//                           value={ratingValue}
//                           onClick={() => handleRating(ratingValue)}
//                           hidden
//                         />
//                         <FaStar
//                           className="star"
//                           color={ratingValue <= (hover || formData.rating) ? '#ffc107' : '#e4e5e9'}
//                           size={32}
//                           onMouseEnter={() => setHover(ratingValue)}
//                           onMouseLeave={() => setHover(null)}
//                         />
//                       </label>
//                     );
//                   })}
//                 </div>
//               </div>

//               {!user && <span className='text-primary'>Login required !</span>}
//               <div className="d-flex justify-content-end">
//                 {user ? (<button type="submit" className="btn btn-primary btn-sm me-2" onClick={createReview}>Submit</button>) : <button type="submit" className="btn btn-primary btn-sm me-2" disabled>Submit</button>}
//               </div>
//             </form>
//           </section>
//         </section>
//       </div>

//       {/* Chat Room */}
//       <ChatRoom vendor={vendor} user={user} />
//     </>
//   );
// }

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../API/axiosInstance";
import { FaStar, FaEye, FaRupeeSign, FaMapMarkerAlt, FaWhatsapp } from "react-icons/fa";
import { getCurrentUser } from "../../Auth/UserServices";
import useAuthCheck from "../../Auth/useAuthCheck";
import ChatRoom from "../ChatRoom/ChatRoom";
import ImageGallery from "./Image Gallery/ImageGallery";
import "./vendorDetails.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
// NEW: Import Bootstrap components for layout and tabs
import { Container, Row, Col, Tabs, Tab, Form, Button } from "react-bootstrap";
import DynamicBreadcrumbs from '../dynamic_breadcumb/dynamic_breadcrumb'
import DownloadAppUI from "../../ui_components/download_app/download_app";
import SiteFooter from "../../ui_components/site_footer/site_footer";

export default function VendorDetails() {
  const [vendor, setVendor] = useState(null);
  const [user, setUser] = useState(null);
  const [vendorServices, setVendorServices] = useState([]);
  const [token, setToken] = useState(null);

  // States for the new contact form in the sidebar
  const [contactForm, setContactForm] = useState({
    fullName: "",
    email: "",
    functionDate: "",
    details: "",
    notifyOnWhatsapp: true,
  });

  // States for the review form
  const [reviewForm, setReviewForm] = useState({
    title: "",
    content: "",
    rating: 0,
  });
  const [hover, setHover] = useState(null);

  const { vendor_id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Fetching logic remains the same...
    const fetchAllData = async () => {
      const storedToken = localStorage.getItem("token");
      if (!storedToken) return;
      setToken(storedToken);

      try {
        const [vendorRes, userRes, servicesRes] = await Promise.all([
          axiosInstance.get(`/vendor/getVendorById/${vendor_id}`),
          getCurrentUser(),
          axiosInstance.get(`/service/${vendor_id}/all`)
        ]);

        if (vendorRes.status === 200) setVendor(vendorRes.data);
        if (userRes) setUser(userRes);
        if (servicesRes.status === 200) setVendorServices(servicesRes.data);

      } catch (err) {
        console.error("Error fetching page data:", err);
      }
    };
    fetchAllData();
  }, [vendor_id]);

  // Handler for the new sidebar contact form
  const handleContactChange = (e) => {
    const { name, value, type, checked } = e.target;
    setContactForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleContactSubmit = (e) => {
    e.preventDefault();
    console.log("Sending message:", contactForm);
    // Add your API call logic here
    alert("Message sent!");
  };

  // Handlers for the review form
  const handleReviewChange = (e) => {
    const { name, value } = e.target;
    setReviewForm(prev => ({ ...prev, [name]: value }));
  };

  const handleRatingChange = (value) => {
    setReviewForm(prev => ({ ...prev, rating: value }));
  };

  const handleReviewSubmit = async (e) => {
    e.preventDefault();
    const reviewData = {
      ...reviewForm,
      userId: user.id,
      vendorId: vendor.id,
      username: user.username,
    };
    console.log("Submitting review:", reviewData);
    // Add your review submission logic here...
    alert("Review submitted!");
  };

  if (!vendor || !user) return <p className="text-center p-5">Loading...</p>;

  return (
    <Container className="vendor-details-page my-4 h-auto">
      {/* SECTION 1: VENDOR HEADER */}
      <Row className="mb-4 h-auto">
        <Col className="mt-0">
          {/* You can add breadcrumbs here */}
          <DynamicBreadcrumbs />
          <h1>{vendor.business_name}</h1>
          <div className="d-flex align-items-center flex-wrap">
            <div className="vendor-rating-box me-3">
              <FaStar /> {vendor.averageRating?.toFixed(1) || 4.8} ({vendor.reviewCount || 52} Reviews)
            </div>
            <div className="text-muted">
              <FaMapMarkerAlt className="me-1" /> {vendor.city}, {vendor.state}
            </div>
          </div>
        </Col>
      </Row>

      {/* SECTION 2: MAIN TWO-COLUMN LAYOUT */}
      <Row>
        {/* === LEFT COLUMN: TABS === */}
        <Col md={8} className="mt-0">
          <Tabs defaultActiveKey="portfolio" id="vendor-details-tabs" className="mb-3 vendor-tabs">
            <Tab eventKey="portfolio" title={`Portfolio (${vendor.business_photos?.length || 0})`}>
              {vendor.business_photos?.length > 0 ? (
                <ImageGallery photos={vendor.business_photos} />
              ) : (
                <p>No photos in portfolio yet.</p>
              )}
            </Tab>

            <Tab eventKey="about" title="About">
              <div className="p-3 border border-top-0">
                <h4>About {vendor.business_name}</h4>
                <p>{vendor.about || "This vendor has not provided a detailed description yet."}</p>
                <hr />
                <h5>Location</h5>
                <p>{vendor.city}, {vendor.state}</p>
                <h5>Category</h5>
                <p>{vendor.business_category}</p>
                <h5>Terms & Conditions</h5>
                <p>{vendor.terms_and_conditions || "No terms specified."}</p>
              </div>
            </Tab>

            <Tab eventKey="services" title={`Services (${vendorServices.length})`}>
              <div className="p-3 border border-top-0">
                <Row xs={1} md={2} className="g-4">
                  {vendorServices.length > 0 ? (
                    vendorServices.map((service) => (
                      <Col key={service.id}>
                        {/* You can reuse your VendorCard component here for consistency */}
                        <div className="card h-100">
                          <img src={service.images?.[0] || "https://placehold.co/600x400"} alt={service.service_name} className="card-img-top" />
                          <div className="card-body">
                            <h5 className="card-title">{service.service_name}</h5>
                            <p className="card-text">{service.description}</p>
                            <p className="fw-bold fs-5 mb-0"><FaRupeeSign /> {service.min_price} - {service.max_price}</p>
                          </div>
                        </div>
                      </Col>
                    ))
                  ) : (
                    <p>No services have been listed by this vendor.</p>
                  )}
                </Row>
              </div>
            </Tab>

            <Tab eventKey="reviews" title={`Reviews (${vendor.reviewCount || 52})`}>
              <div className="p-3 border border-top-0">
                {/* You would map over and display existing reviews here */}
                <div className="mb-4">
                  <h5>Recent Reviews</h5>
                  <p className="text-muted">Display list of existing reviews here...</p>
                </div>
                <hr />
                <h5>Write a Review</h5>
                <Form onSubmit={handleReviewSubmit}>
                  <Form.Group className="mb-3" controlId="reviewTitle">
                    <Form.Label>Review Title</Form.Label>
                    <Form.Control type="text" name="title" value={reviewForm.title} onChange={handleReviewChange} placeholder="e.g., Amazing Experience!" />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="reviewContent">
                    <Form.Label>Your Review</Form.Label>
                    <Form.Control as="textarea" rows={3} name="content" value={reviewForm.content} onChange={handleReviewChange} placeholder="Share your thoughts..." />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Your Rating</Form.Label>
                    <div className="stars">
                      {[...Array(5)].map((_, index) => {
                        const ratingValue = index + 1;
                        return (
                          <FaStar key={ratingValue} className="star" size={30} color={ratingValue <= (hover || reviewForm.rating) ? '#ffc107' : '#e4e5e9'}
                            onMouseEnter={() => setHover(ratingValue)}
                            onMouseLeave={() => setHover(null)}
                            onClick={() => handleRatingChange(ratingValue)}
                          />
                        );
                      })}
                    </div>
                  </Form.Group>
                  <Button variant="primary" type="submit" disabled={!user}>Submit Review</Button>
                </Form>
              </div>
            </Tab>
          </Tabs>
        </Col>

        {/* === RIGHT COLUMN: CONTACT & PRICING SIDEBAR === */}
        <Col md={4}>
          <div className="contact-sidebar p-3 border rounded shadow-sm">
            <h5>Per Day Price Estimate</h5>
            <div className="price-item d-flex justify-content-between border-bottom py-2">
              <span>Photo Package</span>
              <span className="fw-bold"><FaRupeeSign /> 40,000</span>
            </div>
            <div className="price-item d-flex justify-content-between border-bottom py-2 mb-3">
              <span>Photo + Video</span>
              <span className="fw-bold"><FaRupeeSign /> 75,000</span>
            </div>

            <div className="d-grid gap-2 mb-3">
              <Button variant="primary"><FaEye className="me-1" /> View Contact</Button>
            </div>

            <hr />

            <h6 className="text-center mb-3">Send a message to {vendor.business_name}</h6>
            <Form onSubmit={handleContactSubmit}>
              <Form.Group className="mb-3">
                <Form.Control type="text" name="fullName" value={contactForm.fullName} onChange={handleContactChange} placeholder="Full name" required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Control type="email" name="email" value={contactForm.email} onChange={handleContactChange} placeholder="Email address" required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Control type="date" name="functionDate" value={contactForm.functionDate} onChange={handleContactChange} required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Control as="textarea" rows={2} name="details" value={contactForm.details} onChange={handleContactChange} placeholder="Details about my wedding" />
              </Form.Group>
              <Form.Check type="switch" id="whatsapp-switch" name="notifyOnWhatsapp" label="Notify me on Whatsapp" checked={contactForm.notifyOnWhatsapp} onChange={handleContactChange} />
              <div className="d-grid mt-3">
                <Button variant="danger" type="submit">Send Message</Button>
              </div>
            </Form>
          </div>
        </Col>
      </Row>

      <ChatRoom vendor={vendor} user={user} />
      <section className="my-5">
        {/* Download the app */}
        <div id='download-app-container' className='m-0'>
          <DownloadAppUI />
        </div>

        {/* Site Footer */}
        <div>
          <SiteFooter />
        </div>
      </section>
    </Container>
  );
}